module.exports = __webpack_public_path__ + "static/media/menu5x7@1x.51ba66a7.svg";